export default __webpack_public_path__ + "static/media/jisoo1.273ffae4.gif";